export const LOAD_DOCUMENTS_ERROR_MESSAGE = "Failed to load documents";
